// extracted by mini-css-extract-plugin
module.exports = {"group":"_a5901e3","groupInformation":"_b7bd058","event":"_3441ac5","eventInformation":"_b1b2dbb"};